<template>
  <div>
    <div>
      <el-input v-model="msg" :rows="8" type="textarea" placeholder="请输入不通过原因"/>
    </div>
    <div class="dialog-footer" style="text-align: left">
      <el-button size="medium" @click="cancel">返 回</el-button>
      <el-button type="primary"  @click="reject" v-loading="rejectLoading">发送 & 不通过</el-button>
    </div>
  </div>
</template>

<script>
import {postFormData} from "@/api/api";
import {updateBaoApplyState} from "@/api/url"

export default {
  name: "DepositRejectDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idArray: this.value.idArray,
      msg: '你的提现未能通过审核，请填写正确的支付宝账号和实名。',
      rejectLoading: false,
    }
  },
  methods: {

    //返回
    cancel() {
      // this.carForm = this.value.carForm,
      this.$emit('close');
    },

    //提交
    reject() {
      if(!this.msg){
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入不通过原因',
          type: 'warning'
        })
        return false
      }
      this.$confirm('确认不通过选中的用户并发送原因？').then(() => {
        this.rejectLoading = true;
        let _this = this;
        let param = {};
        param['idArr'] = this.idArray;
        param['state'] = 3;
        param['msg'] = this.msg;
        postFormData(updateBaoApplyState,param).then(function(data){
          let {code,msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.$emit('confirm')
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          _this.rejectLoading = false;
        })
            .catch(function(response){
              _this.rejectLoading = false;
            })
      })
          .catch(() => {})
    }

  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
